// extracted by mini-css-extract-plugin
export default {"elementItemList":"ElementItemList_elementItemList__Ie+UA","elementItem":"ElementItemList_elementItem__24wHP"};